import { InspectionType } from '../types'

// 결함의 종류 (defects.inspection_type)
export default {
  INSPECTION_TYPE: {
    STATUS_OUTSIDE: 'STATUS_OUTSIDE', // 외관조사
    TEST_MEASURE: 'TEST_MEASURE', // 정밀점검
  } as const satisfies Record<string, InspectionType>,
}
